
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-mailbox",
      function () {
        return require("private-next-pages/virtual-mailbox.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-mailbox"])
      });
    }
  